export default class SubscriberService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getFormFilterData(params) {
		return this.apiService.callGet('subscribers/form_filter_data', params)
	}

	getSubscriberTypeList(params) {
		return this.apiService.callGet('subscribers/subscriber_types', params)
	}

	deleteSubscribersDevicesCache(params) {
		return this.apiService.callPost('subscribers/delete_device_cache', params)
	}

	// AUTH
	login(user) {
		return this.apiService.callPost('login', user)
	}

	logout() {
		return this.apiService.callPost('logout')
	}

	// SUBSCRIBER
	getEntities(params) {
		return this.apiService.callGet('subscribers', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('subscribers/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('subscribers', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('subscribers/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('subscribers/' + id, params)
	}

	// PROFILE
	getProfiles(id, params) {
		return this.apiService.callGet('subscribers/' + id + '/profiles', params)
	}

	// SUBSCRIBER SERVICE INTERVALS
	getSubscriberServiceIntervals(id, params) {
		return this.apiService.callGet('subscribers/' + id + '/final_service', params)
	}

	// BILLER
	createBiller(subscriberId, params) {
		return this.apiService.callPost('subscribers/' + subscriberId + '/billers', params)
	}

	getBillers(subscriberId, params) {
		return this.apiService.callGet('subscribers/' + subscriberId + '/billers', params)
	}

	// SERVICES
	getSubscriberServices(subscriberId, params) {
		return this.apiService.callGet('subscribers/' + subscriberId + '/services', params)
	}

	updateSubscriberServices(subscriberId, params) {
		return this.apiService.callPost('subscribers/' + subscriberId + '/services', params)
	}

	deleteSubscriberDevicesCache(subscriberId) {
		return this.apiService.callDelete('subscribers/' + subscriberId + '/delete_devices_cache')
	}

	resetSubscriberPassword(subscriberId, params){
		return this.apiService.callPost('subscribers/'+ subscriberId + '/reset_password', params);
	}

	getDeviceGroups(subscriberId, params) {
		return this.apiService.callGet('subscribers/' + subscriberId + '/device_groups', params)
	}

	getOperatorChannels(subscriberId, params) {
		return this.apiService.callGet('subscribers/' + subscriberId + '/operator_channels', params)
	}

	// DEVICES
	getSubscriberDevices(subscriberId, params) {
		return this.apiService.callGet('subscribers/' + subscriberId + '/devices', params)
	}

	getSubscriberPairingCodes(subscriberId, params) {
		return this.apiService.callGet('subscribers/' + subscriberId + '/pairing_codes', params)
	}

	getSubscriberDeviceProfiles(subscriberId, params) {
		return this.apiService.callGet('subscribers/' + subscriberId + '/device_profiles', params)
	}

	// PVR
	getSubscriberPvrs(id, params) {
		return this.apiService.callGet('subscribers/' + id + '/pvrs', params)
	}

	// PERIODIC PVR
	getSubscriberPeriodicPvrs(id, params) {
		return this.apiService.callGet('subscribers/' + id + '/periodic_pvrs', params)
	}

	// FAVORITE SHOWS
	getSubscriberFavoriteShows(id, params) {
		return this.apiService.callGet('subscribers/' + id + '/favorite_shows', params)
	}

	// MESSAGES
	getSubscriberMessages(id, params) {
		return this.apiService.callGet('subscribers/' + id + '/messages', params)
	}

	// ADVERTISING BANNERS
	getSubscriberAdvertisingBanners(id, params) {
		return this.apiService.callGet('subscribers/' + id + '/advertising_banners', params)
	}

	// NOTIFICATIONS
	getSubscriberNotifications(id, params) {
		return this.apiService.callGet('subscribers/' + id + '/notifications', params)
	}

	// DASHBOARD
	getSubscriberDashboard(subscriberId, params) {
		return this.apiService.callGet('subscribers/' + subscriberId + '/dashboard', params)
	}
	updateSubscriberDashboard(subscriberId, params) {
		return this.apiService.callPut('subscribers/' + subscriberId + '/dashboard', params)
	}

	// RESTRICTED_CHANNELS
	getSubscriberProfileRestrictedChannels(subscriberId, params) {
		return this.apiService.callGet('subscribers/' + subscriberId + '/restricted_channels', params)
	}

	updateSubscriberProfileRestrictedChannels(subscriberId, params) {
		return this.apiService.callPut('subscribers/' + subscriberId + '/restricted_channels', params)
	}

	// PURCHASED VOD VIDEOS
	getVodVideosToBuy(subscriberId){
			return this.apiService.callGet('subscribers/' + subscriberId + '/vod_videos_to_buy');
	}

	getSubscriberPurchasedVodVideos(subscriberId, params){
		return this.apiService.callGet('subscribers/' + subscriberId + '/purchased_videos', params);
	}

	addSubscriberPurchasedVodVideo(subscriberId, params){
			return this.apiService.callPost('subscribers/' + subscriberId + '/purchased_videos', params);
	}

	updateSubscriberPurchasedVodVideo(subscriberId, params){
			return this.apiService.callPut('subscribers/' + subscriberId + '/purchased_videos', params);
	}

	deleteSubscriberPurchasedVodVideo(subscriberId, params){
			return this.apiService.callDelete('subscribers/' + subscriberId + '/purchased_videos', params);
	}

	// SEARCH
	searchSubscribers(params) {
		return this.apiService.callGet('subscribers_search', params)
	}

}



// WEBPACK FOOTER //
// ./src/service/SubscriberService.js